import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import TopBar from "@/components/TopBar";
import Footer from "@/components/Footer";
import FloatingCallBtn from "@/components/FloatingCallBtn";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import PortfolioPage from "@/pages/PortfolioPage";
import PortfolioGalleryPage from "@/pages/PortfolioGalleryPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import BookingPage from "@/pages/BookingPage";
import LEDEstimatorPage from "@/pages/LEDEstimatorPage";
import PortfolioAdminPage from "@/pages/PortfolioAdminPage";
import AdminPage from "@/pages/AdminPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function Layout({ children }) {
  return (
    <>
      <TopBar />
      <Navbar />
      <main className="pt-10">{children}</main>
      <Footer />
      <FloatingCallBtn />
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#0f1419]">
      <BrowserRouter>
        <ScrollToTop />
        <Toaster
          position="top-right"
          toastOptions={{
            style: { background: "#131a23", color: "#FAFAFA", border: "1px solid rgba(255,255,255,0.1)" },
          }}
        />
        <Routes>
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/services" element={<Layout><ServicesPage /></Layout>} />
          <Route path="/services/:slug" element={<Layout><ServiceDetailPage /></Layout>} />
          <Route path="/portfolio" element={<Layout><PortfolioPage /></Layout>} />
          <Route path="/portfolio/:slug" element={<Layout><PortfolioGalleryPage /></Layout>} />
          <Route path="/about" element={<Layout><AboutPage /></Layout>} />
          <Route path="/contact" element={<Layout><ContactPage /></Layout>} />
          <Route path="/booking" element={<Layout><BookingPage /></Layout>} />
          <Route path="/led-estimator" element={<Layout><LEDEstimatorPage /></Layout>} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/manage-portfolio" element={<PortfolioAdminPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
